import React from "react";
import { CheckCircle2 } from "lucide-react";

export default function ApiBenefits() {
  const sections = [
    { title: "专利", items: ["专利检索", "基本数据", "引用与回溯", "法律状态与交易", "专利价值评价", "技术分析与提炼", "技术与分类查询"] },
    { title: "商标", items: ["商标检索", "商标基本信息"] },
    { title: "企业", items: ["企业检索", "企业基本信息"] },
  ];

  return (
    <div className="flex-1 p-8 bg-white overflow-y-auto h-[calc(100vh-56px)]">
      <div className="flex items-center justify-between mb-8 border-b border-gray-100 pb-4">
        <div className="flex items-center gap-4">
          <div className="w-48 p-4 bg-white border border-blue-100 rounded-lg shadow-sm">
            <p className="text-xs text-blue-600 font-medium mb-1">当前套餐</p>
            <p className="text-sm font-bold text-gray-800">数源·知海API体验包</p>
            <p className="text-[10px] text-gray-400 mt-2">有效期至：2027-04-15</p>
          </div>
        </div>
        <button className="bg-blue-600 text-white px-6 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors shadow-sm">
          开通套餐
        </button>
      </div>

      <div className="space-y-8">
        <h3 className="text-lg font-bold text-gray-800 border-l-4 border-blue-600 pl-3">包含权益列表</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {sections.map(section => (
            <div key={section.title}>
              <h4 className="text-sm font-bold text-gray-700 mb-4 flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-blue-400 rounded-full"></span>
                {section.title}
              </h4>
              <ul className="space-y-3">
                {section.items.map(item => (
                  <li key={item} className="flex items-center gap-2 text-xs text-gray-500">
                    <CheckCircle2 className="w-3.5 h-3.5 text-blue-500" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
